import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EmbedModeService {
  readonly isEmbedded = signal(false);
  readonly isPreview = signal(false);

  constructor() {
    this.detectEmbeddedMode();
    this.detectPreviewMode();
  }

  private detectEmbeddedMode(): void {
    let inIframe = false;
    try {
      inIframe = window.self !== window.top;
    } catch {
      inIframe = true;
    }

    const isAndroidBridge = !!(window as any).Android;
    const isIOSBridge = !!(window as any).webkit?.messageHandlers?.nativeBridge;

    this.isEmbedded.set(inIframe || isAndroidBridge || isIOSBridge);
  }

  private detectPreviewMode(): void {
    const params = new URLSearchParams(window.location.search);
    const preview = params.get('preview');
    this.isPreview.set(preview === '1' || preview === 'true');
  }
}
